import React, { FC, useState } from 'react';
import { ReactComponent as ChevronUp } from 'assets/icons/ChevronUp.svg';
import { StyledContainer, StyledUserInfoMarquee, StyledExpandedText, StyledText } from './styled';

interface IExpandableTextProps {
  text: string;
  shouldBreak?: boolean;
  speed?: number;
}

const ExpandableText: FC<IExpandableTextProps> = ({ text, shouldBreak = false, speed = 12 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <StyledContainer isExpanded={isExpanded} onClick={handleToggleExpand}>
      {!isExpanded ? (
        <StyledUserInfoMarquee speed={speed}>{text}</StyledUserInfoMarquee>
      ) : (
        <>
          <StyledExpandedText>
            <StyledText shouldBreak={shouldBreak}>{text}</StyledText>
          </StyledExpandedText>
          <ChevronUp />
        </>
      )}
    </StyledContainer>
  );
};

export default ExpandableText;
